const taskSortButtons: SortButton[] = [
   {
      id: 'date',
      icon: 'date',
   },
   {
      id: 'connection',
      icon: 'connections',
   },
   {
      id: 'location',
      icon: 'locations',
   },
]

export { taskSortButtons }
